import React, { Component } from 'react';
import { Button, Card, Col, Form, Input, InputNumber, Row, Select, Checkbox } from 'antd';
import { IndicatorManager } from '../../Shared/IndicatorManager';

const { Option } = Select;

const nestedKeys = ['entry', 'exit', 'stop_loss'];

class StrategyFormComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    handleSubmit(e) {
        e.preventDefault();
        this.props.form.validateFieldsAndScroll((err, values) => {
            if (!err) {
                let data = {};
                Object.keys(values).forEach(key => {
                    let copied = false;
                    nestedKeys.forEach(whitelisted => {
                        if (key.indexOf(whitelisted) === 0) {
                            data[whitelisted] = data[whitelisted] || {};
                            data[whitelisted][key.replace(`${whitelisted}_`, '')] = values[key];
                            copied = true;
                        }
                    });
                    if (!copied && values[key] != null) {
                        data[key] = values[key];
                    }
                });

                this.props.onSubmit(data);
            }
        });
    }

    render() {
        const meta = this.props.data ? this.props.data.meta : {};

        const { getFieldDecorator } = this.props.form;
        return (
            <div>
                <Card title={this.props.title} bordered={false} style={{ marginBottom: 15 }}>
                    <Row gutter={24}>
                        <Col md={4}>
                            <Form.Item label="Type">
                                {getFieldDecorator('type', {
                                    initialValue: 'mako_long',
                                    rules: [{ required: true, message: 'Type is required' }]
                                })(
                                    <Select style={{ width: '100%' }}>
                                        <Option value="mako_long">Long</Option>
                                        <Option value="mako_short">Short</Option>
                                    </Select>
                                )}
                            </Form.Item>
                        </Col>

                        <Col md={8}>
                            <Form.Item label="Name">
                                {getFieldDecorator('name', {
                                    rules: [{ required: true, message: 'Name is required' }]
                                })(<Input />)}
                            </Form.Item>
                        </Col>

                        <Col md={2}>
                            <Form.Item label="Candle style">
                                {getFieldDecorator('candle_style', {
                                    initialValue: 'standard'
                                })(
                                    <Select style={{ width: '100%' }}>
                                        <Option value="standard">Standard</Option>
                                        <Option value="heikin_ashi">Heikin Ashi</Option>
                                    </Select>
                                )}
                            </Form.Item>
                        </Col>

                        <Col md={2}>
                            <Form.Item label="Scan Time">
                                {getFieldDecorator('scan_time', {
                                    initialValue: 'realtime'
                                })(
                                    <Select style={{ width: '100%' }}>
                                        <Option value="realtime">Realtime</Option>
                                        <Option value="30">30 Seconds</Option>
                                        <Option value="60">60 Seconds</Option>
                                        <Option value="120">2 Minutes</Option>
                                        <Option value="300">5 Minutes</Option>
                                        <Option value="900">15 Minutes</Option>
                                        <Option value="1800">30 Minutes</Option>
                                        <Option value="3600">1 Hour</Option>
                                        <Option value="candle_close">Candle Close</Option>
                                    </Select>
                                )}
                            </Form.Item>
                        </Col>
                    </Row>
                </Card>

                <Card title={'Entry Conditions'} bordered={false} style={{ marginBottom: 15 }}>
                    <IndicatorManager
                        enabled
                        form={this.props.form}
                        mode={'entry'}
                        meta={meta}
                        signalPrice={true}
                    />
                </Card>

                <div style={{ textAlign: 'right' }}>
                    <Button onClick={this.handleSubmit.bind(this)} type="primary" size="large">
                        Save
                    </Button>
                </div>
            </div>
        );
    }
}

const mapProps = (prefix, data, acc) => {
    if (!data) return;

    Object.keys(data).forEach(key => {
        acc[`${prefix}_${key}`] = Form.createFormField({ value: data[key] });
    });
};

export const StrategyForm = Form.create({
    mapPropsToFields: props => {
        const data = {};

        Object.keys(props.data || {}).forEach(key => {
            let copied = false;
            nestedKeys.forEach(whitelisted => {
                if (key.indexOf(whitelisted) === 0 && key.indexOf('indicators') === -1) {
                    mapProps(whitelisted, props.data[whitelisted], data);
                    copied = true;
                    return;
                }
            });

            if (!copied) data[key] = Form.createFormField({ value: props.data[key] });
        });
        return data;
    }
})(StrategyFormComponent);



// WEBPACK FOOTER //
// ./src/Account/Strategies/MakoStrategies/Shared/Form.js